// extracted by mini-css-extract-plugin
export default {"cls1":"CollapsedActivityPreview-cls1___496b595b14a0d720cf3","cls2":"CollapsedActivityPreview-cls2__e3d73262912bda11ead6 CollapsedActivityPreview-cls1___496b595b14a0d720cf3"};